module.exports = __webpack_public_path__ + "img/file-invoice-dollar-solid.4c212de9.png";